import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import PropTypes from "prop-types";

const RequireAction = ({ actionId, checkType = false }) => {
    const user = useSelector((state) => state.auth.user);
    const hasAction = checkType ? user?.actions?.some((action) => action.type === actionId) : user?.actions?.some((action) => action.id === actionId);

    if (hasAction) {
        return <Outlet />;
    } else {
        return <Navigate to="/forbidden" />;
    }
};

RequireAction.propTypes = {
    actionId: PropTypes.string,
    checkType: PropTypes.bool,
};

export default RequireAction;
